import { render, staticRenderFns } from "./TransactionHistoryContainer.vue?vue&type=template&id=0e0438f4&"
import script from "./TransactionHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports